const keyPrefix = '@connectone';

const parseValue = (value) => {
  try {
    return JSON.parse(value) || value;
  } catch (e) {}

  return value;
};

const formatValue = (value) => {
  if (typeof value === 'object') return JSON.stringify(value);
  return value;
};

const getFromStorage = (storage, key) =>
  parseValue(storage.getItem(`${keyPrefix}/${key}`));

const setToStorage = (storage, key, data) =>
  storage.setItem(`${keyPrefix}/${key}`, formatValue(data));

const removeFromStorage = (storage, key) =>
  storage.removeItem(`${keyPrefix}/${key}`);

const createStorageInterface = (...args) => {
  return {
    /* получить значение по ключу */
    get: getFromStorage.bind(null, ...args),
    /* сохранить значение по ключу */
    set: setToStorage.bind(null, ...args),
    /* удалить ключ */
    remove: removeFromStorage.bind(null, ...args),
    /* создать интерфейс для одного ключа */
    byKey: createStorageInterface.bind(null, ...args),
  };
};

/* единый интерфейс для работы с сессионным и локальным хранилищами */
export const storage = {
  /* интерфейс для работы с сессионным хранилищем */
  session: createStorageInterface(sessionStorage),
  /* интерфейс для работы с локальным хранилищем */
  local: createStorageInterface(localStorage),
};
